import { Input, message, Modal } from 'antd-v5';
import { useCallback, useState } from 'react';

export const ExportClientsModal = ({ open, onClose, onSubmit, userEmail }) => {
  const [email, setEmail] = useState(userEmail || null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      await onSubmit(email);
      message.success('Your client list is being exported. You will receive an email shortly.');
    } catch (error) {
      console.log(error);
      message.error('There was an error exporting your client list. Please try again.');
    } finally {
      setLoading(false);
      setEmail(null);
      onClose();
    }
  }, [email, onSubmit]);

  return (
    <Modal
      title="Would you like to export your client list?"
      open={open}
      onOk={handleSubmit}
      onCancel={onClose}
      width={450}
      destroyOnClose
      okText="Export"
      confirmLoading={loading}
    >
      <div className="flex-col-left">
        <span className="fs-13 gray">
          You will receive an email with a link to a CSV file using any filters you have selected.
        </span>
        <span className="fs-14 fw-500">Email:</span>
        <Input type="email" value={email} onChange={e => setEmail(e.target.value)} name="export-email" />
      </div>
    </Modal>
  );
};
